export const ebayAccountsList = [
  {
    label: 'dv-int-ing',
    value: 'dvinternationaltrading',
  },
  {
    label: 'vanautosale',
    value: 'vanautosale',
  },
  {
    label: '2dayEbay',
    value: '2dayEbay',
  }
];

export default ebayAccountsList;
